export default __webpack_public_path__ + "static/media/horse-ride.1966dd20.svg";